import { useState } from "react";
import { Ikon, SatirDugmesi, SatirMetni, SayfaBasligi, type IkonAdi } from "@koclukpanel/ui";
import { Bildirimlerim } from "./Bildirimlerim";
import { AksamHatirlatmaAyari } from "./AksamHatirlatmaAyari";
import { ProfilGorselim } from "./ProfilGorselim";
import { DegisiklikTalebi } from "./DegisiklikTalebi";
import { Guvenlik } from "./Guvenlik";
import { NasilKullanilir } from "./NasilKullanilir";
import { Mesajlar } from "./Mesajlar";
import { Onaylarim } from "./Onaylarim";
import { TalepKutusu } from "./TalepKutusu";
import { KvkkBasvurularim } from "./KvkkBasvurularim";
import { CanliBilgilendirmeSayfasi } from "./CanliBilgilendirmeSayfasi";
import { useCanliIzleme } from "./canli-izleme";

/**
 * HESABIM — günlük olmayan işlerin merkezi
 *
 * ================================================================
 * NEDEN BİR MERKEZ, NEDEN DÖRT AYRI SEKME DEĞİL
 * ================================================================
 * Bu dördü de yılda birkaç kez açılıyor: program isteği ayda bir hak,
 * istek-yardım gerektiğinde, onaylar rıza değiştiğinde, güvenlik şifre
 * ya da 2FA değişiminde. Günlük gezintide dört yer kaplamaları, her
 * gün kullanılan dördünü (Bugün · Takvim · Denemeler · Hata defterim)
 * ekranın dışına itiyordu.
 *
 * Önceki hâl daha kötüydü: sekiz sekme yatay KAYDIRILARAK
 * gösteriliyordu. Kaydırılan bir gezinti, görünmeyen girdilerin var
 * olduğunu da gizler — öğrenci "Onaylarım"ı ancak şeridi iterse
 * buluyordu. Çizimin kendi notu da bunu söylüyor.
 *
 * ================================================================
 * MERKEZ BİR LİSTE, MENÜ DEĞİL
 * ================================================================
 * Her satır ne olduğunu ve NE ZAMAN gerektiğini yazıyor. "Güvenlik"
 * tek başına bir öğrenciye pek bir şey söylemiyor; "şifre ve iki
 * aşamalı doğrulama" söylüyor.
 *
 * ================================================================
 * AÇIKLAMALAR 390px'E SIĞMAK ZORUNDA — ÖLÇÜLDÜ
 * ================================================================
 * `SatirMetni` alt başlığı `truncate` ile çiziyor, yani sığmayan
 * metin sessizce üç noktaya kesiliyor. 04.09.2026'da 390px'te canlı
 * ölçüldü: program satırının açıklaması 314px yer istiyordu, 279px
 * vardı — ekranda *"…ayda bi…"* diye kesiliyordu.
 *
 * Kesilen kısım tam da bu listenin var oluş sebebiydi: satırın NE
 * ZAMAN gerektiğini söyleyen yarısı. jsdom testi bunu göremez
 * (yerleşim ölçmez) ve gerçekten de `Hesabim.test.tsx` metni DOM'da
 * bulup geçiyordu — öğrenci okuyamıyorken.
 *
 * Bu yüzden açıklamalar KISA tutulmak zorunda; sınır
 * `Hesabim.test.tsx` içinde ölçülmüş bir sayıyla sabitlendi.
 */

type AltEkran =
  | "menu"
  | "mesaj"
  | "bildirim"
  | "gorsel"
  | "degisiklik"
  | "talep"
  | "onay"
  | "kvkk"
  | "guvenlik"
  | "yardim"
  | "canliIzleme";

interface Girdi {
  anahtar: Exclude<AltEkran, "menu">;
  baslik: string;
  aciklama: string;
  ikon: IkonAdi;
}

const GIRDILER: readonly Girdi[] = [
  /*
    ================================================================
    MESAJLAR EN ÜSTTE — ÖTEKİLERDEN FARKLI BİR ŞEY
    ================================================================
    Bu listenin geri kalanı "yılda birkaç kez" işler; mesaj öyle değil,
    KARŞI TARAF BEKLİYOR olabilir. Alta koysaydık gecikmenin bedelini
    öğrenci değil karşısındaki kişi öderdi.

    9b: mesajların kendi üst çubuk düğmesi (balon) ve kendi sayısı var
    (`Kabuk.tsx`); bu satır listede de kalıyor, rozetiyle.

    "İstek ve yardım"dan AYRI ve ayrımı satır metni söylüyor: orası bir
    kuyruk (kategorisi, durumu, karar veren biri var), burası bir
    yazışma.
  */
  {
    anahtar: "mesaj",
    baslik: "Mesajlar",
    aciklama: "Koçunla ve kurumla yazış",
    ikon: "gorusme",
  },
  /*
    ================================================================
    BİLDİRİMLER — F-NTF-09, MESAJIN HEMEN ALTINDA
    ================================================================
    İkisi de "biri sana bir şey söyledi" satırı, ama aynı şey değil:
    mesajın karşısında BEKLEYEN BİR İNSAN var, bildirimi sistem
    üretiyor. O yüzden mesaj önce.

    9b: zil üst çubukta, kendi sayısıyla; satır listede de kalıyor.
  */
  {
    anahtar: "bildirim",
    baslik: "Bildirimler",
    aciklama: "Sistemin sana ilettikleri",
    ikon: "bildirim",
  },
  {
    anahtar: "degisiklik",
    baslik: "Program isteği",
    aciklama: "Programında değişiklik iste — ayda bir hak",
    ikon: "program",
  },
  {
    anahtar: "talep",
    baslik: "İstek ve yardım",
    /*
      Açılan ekran "Kuruma bir isteğin varsa buradan yazabilirsin" diyor ve
      kategoriler destek türleri (çalışmıyor / nasıl yapılır / öneri).
      Satır "Koçuna soru sor" diyordu — o iş Mesajlar'ın (UI/UX Dalga 1, Ö6).
    */
    aciklama: "Kuruma istek ilet, takılınca destek al",
    ikon: "talep",
  },
  /*
    ================================================================
    PROFİL GÖRSELİ — F-PPL-13
    ================================================================
    Uçlar 04.09.2026'dan beri öğrenciye de açıktı (`@KimlikGerekli()`,
    izin sormuyorlar) ama bu uygulamada "avatar" kelimesi HİÇ
    geçmiyordu. Şartname "her kullanıcı kendi profil görselini
    belirleyebilir" diyor ve bu sistemin kullanıcılarının çoğunluğu
    öğrenci.

    Sıralamada burada: mesaj ve bildirim "biri sana bir şey söyledi"
    satırları, gerisi ayar. Görsel de bir ayar ve en sık açılacak olanı
    değil.
  */
  {
    anahtar: "gorsel",
    baslik: "Profil görselim",
    aciklama: "Avatarını ya da fotoğrafını seç",
    ikon: "hesap",
  },
  {
    anahtar: "onay",
    baslik: "Onaylarım",
    aciklama: "Verinin nasıl kullanıldığına dair izinlerin",
    ikon: "onay",
  },
  // F-LGL-02b — başvuru hakkı zorunlu onay kilidine bağlı değildir.
  {
    anahtar: "kvkk",
    baslik: "KVKK başvurularım",
    aciklama: "Kişisel verilerin için başvur",
    ikon: "onay",
  },
  {
    anahtar: "guvenlik",
    baslik: "Güvenlik",
    aciklama: "Şifre ve iki aşamalı doğrulama",
    ikon: "rol",
  },
  /*
    NASIL KULLANILIR — yardım aşama 1 (05.10.2026). Hesabım'da çünkü
    günlük iş değil, takılınca açılan bir yer; alt şerit beş girdide
    kalıyor (Kabuk.tsx). Açıklama 390px sınırının altında (test ölçüyor).
  */
  {
    anahtar: "yardim",
    baslik: "Nasıl kullanılır",
    aciklama: "Uygulamayı adım adım öğren",
    ikon: "yardim",
  },
  /*
    F-LIV-07 — CANLI CALISMA IZLEME BILGILENDIRMESI. Satir YALNIZ modul aciksa listeleniyor (asagida
    suzuluyor): kapaliyken "koc ne goruyor" sorusunun cevabi "hicbir sey" ve satir bos bir vaat olurdu.
    Gorev kartindaki "Ayrinti" modul aciksa ayni alt ekrani `baslangic` ile dogrudan acar.
  */
  {
    anahtar: "canliIzleme",
    baslik: "Canlı çalışma izleme",
    aciklama: "Koçunun neyi gördüğünü öğren",
    ikon: "bilgi",
  },
  /*
    ÖDÜLLER SATIRI YOK — 9b'den beri kendi alt şerit girdisi var ("Ödüller",
    Kabuk.tsx). Burada ikinci bir yol açmak menüyü yine karıştırırdı.
  */
];

/** Listede çizilmeyen alt ekranlar — yalnız üst çubuktan açılıyor (Kabuk.tsx). */
const LISTEDE_YOK: ReadonlySet<AltEkran> = new Set<AltEkran>(["mesaj", "bildirim"]);

interface HesabimProps {
  /**
   * Doğrudan açılacak alt ekran.
   *
   * BAŞKA BİR EKRANDAN GELEN İSTEK İÇİN. Haftalık programdaki
   * "Değişiklik iste" düğmesi öğrenciyi buraya yolluyor; menüye
   * bırakıp "şimdi de Program isteği'ne bas" demek, düğmenin sözünü
   * yarım tutmak olurdu.
   */
  baslangic?: Exclude<AltEkran, "menu">;
  /**
   * Bir yazışma okundu — kabuktaki okunmamış rozeti tazelensin.
   *
   * Sayaç `Uygulama.tsx` içinde ve 60 saniyede bir dönüyor; okuma
   * anında haber vermeseydik rozet, öğrenci mesajı okuduktan sonra
   * bir dakika daha durur ve gördüğüyle çelişirdi.
   */
  onMesajOkundu?: () => void;
  /**
   * Bir bildirim okundu — kabuktaki rozet tazelensin.
   *
   * `onMesajOkundu` ile AYRI: ikisi ayrı uçtan sayılıyor ve tek bir
   * geri çağrı, okunan mesajdan sonra bildirim sayacını da boşuna
   * tazelerdi. Balon ve zil ayrı sayıyor (`Kabuk.tsx`).
   */
  onBildirimOkundu?: () => void;
  /**
   * Çıkış — UI/UX Dalga 2 (M8): alt şeritte/üst çubukta yer tutan düğme
   * buraya taşındı. Sık basılan bir işlem değil; yanlışlıkla basmak da
   * çevrimdışı önbelleği düşürdüğü için pahalı. Verilmezse satır çizilmez
   * (Hesabım tek başına test edilebilsin).
   */
  onCikis?: () => void;
}

export function Hesabim({
  baslangic,
  onMesajOkundu,
  onBildirimOkundu,
  onCikis,
}: HesabimProps = {}) {
  const [ekran, setEkran] = useState<AltEkran>(baslangic ?? "menu");
  const canli = useCanliIzleme();

  if (ekran !== "menu") {
    const girdi = GIRDILER.find((g) => g.anahtar === ekran)!;
    return (
      <div className="flex flex-1 flex-col">
        {/*
          GERİ DÜĞMESİ ŞART. Alt şeritte "Hesabım" seçili kalıyor, yani
          öğrenci hangi bölümde olduğunu biliyor — ama alt ekrandan
          çıkmanın yolu yoksa tek çıkış tarayıcının geri tuşu olurdu ve
          PWA'da o tuş her zaman görünmüyor.
        */}
        <div className="flex items-center gap-2 px-4 pt-4 lg:pt-2">
          <button
            type="button"
            onClick={() => setEkran("menu")}
            className="min-h-dokunma text-mor-700 hover:bg-mor-50 inline-flex items-center rounded-xl px-2 text-sm font-semibold"
          >
            ← Hesabım
          </button>
          <span aria-hidden="true" className="text-metin-ikincil text-sm">
            /
          </span>
          <span className="text-metin-koyu text-sm font-semibold">{girdi.baslik}</span>
        </div>
        {ekran === "mesaj" && <Mesajlar onOkundu={onMesajOkundu} />}
        {ekran === "bildirim" && (
          <>
            {/* F-NTF-12 — Emre 05.10.2026: ogrenci aksam hatirlatmasini kapatabilir */}
            <AksamHatirlatmaAyari />
            <Bildirimlerim onOkundu={onBildirimOkundu} />
          </>
        )}
        {ekran === "gorsel" && <ProfilGorselim />}
        {ekran === "degisiklik" && <DegisiklikTalebi />}
        {ekran === "talep" && <TalepKutusu />}
        {ekran === "onay" && <Onaylarim />}
        {ekran === "kvkk" && (
          <div className="p-4">
            <KvkkBasvurularim />
          </div>
        )}
        {ekran === "guvenlik" && <Guvenlik />}
        {ekran === "yardim" && <NasilKullanilir />}
        {ekran === "canliIzleme" && (
          <div className="p-4">
            <CanliBilgilendirmeSayfasi />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col gap-4 p-4 lg:px-4 lg:py-2">
      <SayfaBasligi
        baslik="Hesabım"
        aciklama="Mesajların, ayarların, izinlerin ve güvenliğin tek yerde."
        ikon="hesap"
      />
      <ul data-hesap-listesi className="flex flex-col gap-2 lg:grid lg:grid-cols-2">
        {/*
          MESAJLAR VE BİLDİRİMLER LİSTEDE YOK — Emre kararı (9b): ikisi yalnız üst çubuktan
          (balon ve zil, kendi sayılarıyla) açılıyor. Alt ekranlar duruyor: balon/zil
          `baslangic` ile doğrudan onları açıyor; listede ikinci bir yol menüyü yine
          kalabalıklaştırırdı.
        */}
        {GIRDILER.filter(
          (g) => !LISTEDE_YOK.has(g.anahtar) && (g.anahtar !== "canliIzleme" || canli.acik),
        ).map((g) => {
          return (
            <li key={g.anahtar}>
              <SatirDugmesi onClick={() => setEkran(g.anahtar)}>
                {/*
                  İKON KAROSU YOK, BİLEREK: 40 px'lik karo açıklamanın 390 px'teki yerini 20 px
                  daraltıyordu ve Poppins Inter'den geniş — "…ayda bir hak" yine kesiliyordu
                  (kanit-9b ölçümü). Renk ikonda, yer metinde.
                */}
                <Ikon ad={g.ikon} className="text-mor-500" />
                <SatirMetni baslik={g.baslik} altBaslik={g.aciklama} />
                {/* Yön işareti `aria-hidden`: düğmenin adı zaten başlık. */}
                <span aria-hidden="true" className="text-notr-400 shrink-0">
                  ›
                </span>
              </SatirDugmesi>
            </li>
          );
        })}
        {onCikis && (
          <li>
            <SatirDugmesi onClick={onCikis}>
              <SatirMetni baslik="Çıkış yap" altBaslik="Bu cihazdaki çevrimdışı veriler silinir" />
            </SatirDugmesi>
          </li>
        )}
      </ul>
    </div>
  );
}
